import { ArrowUpRight, BookOpen } from "lucide-react";
import Reveal from "./Reveal";
import { BEYOND } from "@/config/clinicConfig";

export default function Beyond() {
  return (
    <section id="beyond" data-testid="beyond-section" className="bg-sand py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <Reveal className="relative">
          <div className="overflow-hidden rounded-[2rem] shadow-[0_30px_80px_-40px_rgba(44,34,30,0.5)] transition-[transform,box-shadow] duration-500 ease-out hover:-translate-y-2 hover:rotate-[-0.5deg] hover:shadow-[0_45px_100px_-40px_rgba(44,34,30,0.65)]">
            <img
              src={BEYOND.bookImage}
              alt="Cosmetic Bodies Beyond the Border — memoir by Sherry Lyn Corvino"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
          <img
            src={BEYOND.portraitImage}
            alt="Author Sherry Corvino"
            loading="lazy"
            className="absolute -bottom-8 -right-3 hidden w-36 rounded-2xl border-4 border-cream object-cover shadow-xl sm:block lg:w-44"
          />
        </Reveal>

        <div>
          <Reveal>
            <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-clay">
              <BookOpen size={15} />
              {BEYOND.eyebrow}
            </p>
            <h2 className="mt-4 text-balance font-display text-3xl font-medium leading-snug tracking-tight text-espresso sm:text-4xl lg:text-[2.75rem]">
              {BEYOND.heading}
            </h2>
            <p className="mt-5 font-display text-xl italic text-clay">“{BEYOND.quote}”</p>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-cocoa sm:text-lg">{BEYOND.body}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              data-testid="beyond-cta"
              href={BEYOND.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-espresso px-7 py-3.5 text-sm font-semibold text-cream transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-clay"
            >
              {BEYOND.cta}
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
